import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '../../../../core/animations';
import { RecommendationService } from '../../../../core/services/recommendation.service';
import { FuseNavigationService } from '../../../../core/components/navigation/navigation.service';

@Component({
  selector: 'recommendation-blogs',
  templateUrl: './recommendation-blogs.component.html',
  styleUrls: ['./recommendation-blogs.component.scss'],
  standalone: false,
  animations: fuseAnimations
})

export class RecommendationBlogsComponent implements OnInit {
  currentIndex = 0;
  blogs: any = [];
  loading = true;
  constructor(private recommendationService: RecommendationService, private navigationService: FuseNavigationService) { }
  ngOnInit() {
    this.getRecommendationBlogs();
    const blogNavItem = this.navigationService.getNavigationItem('recommendation.recommendation-blog');
    if (blogNavItem?.badge)  {
      const recommendationNavItem = this.navigationService.getNavigationItem('recommendation');
      if (recommendationNavItem.badge) recommendationNavItem.badge = recommendationNavItem.badge - blogNavItem.badge;
      blogNavItem.badge = 0;
    }
  }

  getRecommendationBlogs(): void {
    this.recommendationService.recommendations('blog').subscribe((blogs: any) => {
      this.recommendationService.favoriteRecommendation().subscribe((favorEvent: any) => {
        if (blogs){
          for (let i = 0; i < favorEvent.length; i++) {
            let index = blogs.findIndex(event => +event.id === +favorEvent[i].recommendationId);
            if (index > -1) {
              blogs[index].isFavorite = true;
              blogs[index].favId = favorEvent[i].id;
            }
          }
          this.blogs = blogs;
        }
        this.loading = false;
      });
    })
  }

  scrollCarousel(direction) {
    const carousel = document.getElementById('carousel');
    const cards = carousel.children;
    const total = cards.length;

    this.currentIndex += direction;

    if (this.currentIndex < 0) this.currentIndex = 0;
    if (this.currentIndex >= total) this.currentIndex = total - 1;

    const offset = -this.currentIndex * 100;
    carousel.style.transform = `translateX(${offset}%)`;
  }

  deleteBlog(index: number) {
    this.blogs.splice(index, 1);
    if (this.currentIndex > 0) this.scrollCarousel(-1);
  }
}
